import { useState, useEffect } from 'react';

const ColorPicker = ({setDataObject, initialColor}) => {
  const [color, setColor] = useState(initialColor? initialColor : '#000000');

useEffect(() => {
    setColor(initialColor)
  }, [initialColor]);

  const handleChange = (event) => {
    setColor(event.target.value);
    setDataObject((obj) => ({ ...obj, tagColor: event.target.value }))
  };

  return (
    <div>
      <label htmlFor="colorPicker">Pick a Color:</label>
      &nbsp;
      <input
        type="color"
        id="colorPicker"
        value={color}
        onChange={handleChange}
      />
        <></>
      
    </div>
  );
}

export default ColorPicker;
